const s = (e) => !e.disabled && !e.hidden;
export {
  s
};
